import useMutatedPagePath from "features/shared/hooks/analytics/useMutatedPagePath";
import { useCallback, useState } from "react";
import AnalyticsService from "services/analytics/analytics";
import { useAppStore } from "store/store";
import { getGeneralAnalyticsParams } from "./useGeneralAnalytics";

export type ScannerAnalyticsEventType =
  | "scanner_selected"
  | "scanner_success"
  | "scanner_side_success"
  | "scanner_fail"
  | "scanner_closed"
  | "scanner_error_shown"
  | "re_scan_chosen"
  | "low_res_warning_shown"
  | "mb_new_frame_analysis"
  | "blinkid_error";

const useScannerAnalytics = (itemType: string) => {
  const locale = useAppStore((state) => state.locale);

  const [path, title, location] = useMutatedPagePath();
  const paxSessions = useAppStore((state) => state.paxSessions);
  const journey = useAppStore((state) => state.journey);

  const [scanStartTime] = useState<number>(new Date().getTime());

  const sendAnalyticsEvent = useCallback(
    (eventType: ScannerAnalyticsEventType) => {
      AnalyticsService.shared.trackEvent(
        eventType,
        {
          ...getGeneralAnalyticsParams(
            paxSessions,
            journey,
            path,
            title,
            location,
            locale
          ),
          item_type: itemType,
          scanner_work_duration: (new Date().getTime() - scanStartTime) / 1000,
        },
        // isScanRelated - these all are scanner events
        true
      );
    },
    [
      itemType,
      location,
      path,
      scanStartTime,
      title,
      journey,
      locale,
      paxSessions,
    ]
  );

  return sendAnalyticsEvent;
};

export default useScannerAnalytics;
